import React from "react";
import { Link } from "react-router-dom";

export const Resources = ({
  note_url,
  mq_url,
  cq_url,
  lw_url,
  soln_url,
  tb_url,
  assignment_url,
  ms_url,
}) => {
  return (
    <div className="resources  my-2">
      {ms_url && (
        <Link to={ms_url} className="link">
          <span className="card small my-1">Micro Syllabus</span>
        </Link>
      )}
      {tb_url && (
        <Link to={tb_url} className="link">
          <span className="card small my-1">Text Book</span>
        </Link>
      )}
      {note_url && (
        <Link to={note_url} className="link">
          <span className="card small my-1">Notes</span>
        </Link>
      )}
      {lw_url && (
        <Link to={lw_url} className="link">
          <span className="card small my-1">Laboratory Works</span>
        </Link>
      )}
      {mq_url && (
        <Link to={mq_url} className="link">
          <span className="card small my-1">Model Question</span>
        </Link>
      )}
      {cq_url && (
        <Link to={cq_url} className="link">
          <span className="card small my-1">College Question</span>
        </Link>
      )}

      {soln_url && (
        <Link to={soln_url} className="link">
          <span className="card small my-1">Solution</span>
        </Link>
      )}

      {assignment_url && (
        <Link to={assignment_url} className="link">
          <span className="card small my-1">Assignment</span>
        </Link>
      )}
    </div>
  );
};
